<template>
  <section class="search-results-module has-section-spacer is-padding has-bg-gray-10">

    <div v-if="noResults" class="search-no-result hide" data-behavior="vue-search-app__no-results">
        <div class="container"><strong>{{ searchTerm }}</strong> returned no results, please try again.</div>
    </div>

    <div class="container">
      <div v-if="results != null && results.length > 0">
          <SearchResults />
      </div>
      <div v-if="results == null || results.length === 0">
          <MostPopular />
          <Recommended />
      </div>
    </div>
  </section>
</template>

<script>
import $ from "webpack-zepto";
import SearchResults from "./grids/search/SearchResults";
import MostPopular from "./grids/mostPopular/MostPopular";
import Recommended from "./grids/recommended/Recommended";

export default {
  name: "Grids",
  computed: {
    results: function () {
      return this.$store.state.searchResults;
    },
    searchTerm: function () {
      return this.$store.state.searchTerm;
    },
    discoverMode: function() {
      return this.$store.state.discoverMode;
    },
    noResults: function() {
      return this.$store.state.searchResults != null && this.$store.state.searchResults.length === 0 && this.$store.state.searchTerm;
    }  
  },
  watch: {
    noResults: function() {
      if ( this.noResults ) { setTimeout(() => { $("[data-behavior='vue-search-app__no-results']").removeClass('hide'); }, 500); }
    }
  },
  components: {
    SearchResults,
    MostPopular,
    Recommended,
  },
  updated() {
    $(document).trigger('SearchAppUpdated');
    setTimeout(() => { $(document).trigger('SearchAppUpdated'); }, 1500);
  }  
};
</script>